import React from 'react';

import cn from 'classnames';

import { formatPrettyValue, I18n } from '@utils/index';

import { CoinTag } from './CoinTag';
import { Item } from './Item';

import styles from './index.module.css';

export const KLineHeader = (props) => {
  const {
    className, coinArr, value, price, priceClass, favoriteChange, isFavorite,
    riseAndFall, riseAndFallClass, highPrice, lowPrice, volume, coinDetail
  } = props;
  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={cn(styles.titleWrapper)}>
        <CoinTag className={styles.coinTag} text={`${coinArr?.[0]}/${coinArr?.[1]}`} coinDetail={coinDetail} />
        <span onClick={favoriteChange} className={cn('icon', 'icon-pointer', styles.icon, {
          'icon-star-selected': isFavorite,
          'icon-star': !isFavorite
        })} />
      </div>
      <div className={styles.main}>
        <div className={cn(styles.itemWrapper, styles.priceWrapper)}>
          <Item
            className={cn(styles.pcItem)}
            topClass={cn(styles.price, priceClass, 'DINPro-Medium')}
            label={formatPrettyValue(price)}
            bottomClass={cn(styles.bottomTextMargin, styles.h5lh16)}
            value={(
              <>
                <span className={cn(styles.bottomText, 'DINPro')}>{value}</span>
                <span className={cn(styles.pcHide, styles.h5Fluctuation, riseAndFallClass)}>{riseAndFall}</span>
              </>
            )} />
          <Item
            className={cn(styles.pcItem, styles.h5Hide)}
            topClass={cn(styles.topText)}
            bottomClass={cn(styles.bottomText, styles.bottomTextMargin, riseAndFallClass, 'DINPro')}
            label={I18n.t('24hChange')}
            value={riseAndFall} />
        </div>
        <div className={cn(styles.itemWrapper)}>
          <Item
            className={cn(styles.pcItem, styles.h5Item)}
            topClass={cn(styles.topText, styles.h5TopText)}
            bottomClass={cn(styles.bottomText, styles.h5BottomText, styles.bottomTextMargin, 'DINPro')}
            label={`24h ${I18n.t('high')}`}
            value={highPrice} />
          <Item
            className={cn(styles.pcItem, styles.h5Item)}
            topClass={cn(styles.topText, styles.h5TopText)}
            bottomClass={cn(styles.bottomText, styles.h5BottomText, styles.bottomTextMargin, 'DINPro')}
            label={`24h ${I18n.t('low')}`}
            value={lowPrice} />
          <Item
            className={cn(styles.pcItem, styles.h5Item)}
            topClass={cn(styles.topText, styles.h5TopText)}
            bottomClass={cn(styles.bottomText, styles.h5BottomText, styles.bottomTextMargin, 'DINPro')}
            label={`24h ${I18n.t('vol')}(${coinArr?.[0]})`}
            value={volume} />
        </div>
      </div>
    </div>
  )
}
